// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"15125":"2cf57653c212ec4bd626","25825":"e054513f4e90b5cfb27e","80020":"d9d7a66872002bc4af69"}[chunkId] + ".css";
};